module.exports = __webpack_public_path__ + "static/media/11-4.72893bc1.mp3";